import React, {useContext} from 'react';
import * as PropTypes from 'prop-types';

import nbspier from 'ati-utils/nbspier';
import Tooltip from '@components/tooltip';
import {classes} from 'as-ui-kit/utils/styles';

import {DataContext} from 'contexts';

import styles from './styles.modules.scss';

const FirmIcon = ({imageClassName, id, icon, size}) => {
    const { openPassport } = useContext(DataContext);

    if(!icon){
        return null;
    }

    const link = size === 'default'? icon.imageLink : icon.imageLinks?.[size];

    const iconJSX = (
        <img
            alt=""
            className={classes(styles['icon-image'], imageClassName)}
            src={link}
        />
    );

    return (
        <div
            className={styles['firm-icon']}
            onClick={() => openPassport(id)}
        >
            {icon.body ? (
                <Tooltip
                    isWithoutWrapper
                    content={(
                        <div>
                            {icon.title && (
                                <p className={styles['tooltip-title']}>
                                    {nbspier(icon.title)}
                                </p>
                            )}
                            {icon.body && (
                                <span
                                    className={styles['tooltip-body']}
                                    dangerouslySetInnerHTML={{ __html: icon.body }}
                                />
                            )}
                        </div>
                    )}
                    maxWidth={235}
                >
                    {iconJSX}
                </Tooltip>
            ) : iconJSX}
        </div>
    );
};

export default FirmIcon;
FirmIcon.defaultProps = {
    size: 'default'
};

FirmIcon.propTypes = {
    icon: PropTypes.object,
    id: PropTypes.string,
    imageClassName: PropTypes.string,
    size: PropTypes.oneOf(['default', 'small', 'extraLarge', 'large', 'medium'])
};
